export default [
  'ResourceService',
  class UserService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/users';
    }

    getSavedPayment(slug) {
      if (!slug) {
        return this._resourceService.errorPromise('missing params');
      }
      return this._resourceService.get(`${this._API_BASE}/${slug}/payment`)
    }

    linkOrder(id, orderNum, emailAddress) {
      if (!id || !orderNum || !emailAddress) {
        return this._resourceService.errorPromise('missing params');
      }
      return this._resourceService.patch(`${this._API_BASE}/${id}/orders`, {
        'user_email': emailAddress,
        'orders': [orderNum]
      });
    }

    updateAddress(slug, name, address, city, state, zip, country, mobile = null, apt = null) {
      if (!slug) {
        return this._resourceService.errorPromise('missing params');
      }
      return this._resourceService.put(`${this._API_BASE}/${slug}/address`, {
        name,
        address,
        city,
        state,
        zip,
        country,
        mobile,
        apt
      })
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/api-services/user-service.js